module.exports = "<div class=\"sheet-container animated {{animation}} {{themeColor}}\" [style.display]=\"display\"><ng-content></ng-content></div>";


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/ui/sheet/sheet.component.pug
// module id = 270
// module chunks = 0